import { create } from "zustand";

interface StylingPanelStore {
  temporaryFieldDisplayOverrides: Record<string, string>;
  setTemporaryFieldDisplayOverride: (field: string, value?: string) => void;
}

export const useStylingPanelStore = create<StylingPanelStore>((set, get) => ({
  temporaryFieldDisplayOverrides: {},
  setTemporaryFieldDisplayOverride: (field, value) => {
    const newTemporaryFieldDisplayOverrides = {
      ...get().temporaryFieldDisplayOverrides,
    };
    if (value === undefined) {
      delete newTemporaryFieldDisplayOverrides[field];
    } else {
      newTemporaryFieldDisplayOverrides[field] = value;
    }
    set({
      temporaryFieldDisplayOverrides: newTemporaryFieldDisplayOverrides,
    });
  },
}));
